<template>
  <div v-if="isSupport">
    <!-- 187ウエディング記事はCreativePrintで印刷させないため、モバイルOSの時は印刷ボタンを非表示にする-->
    <p v-if="this.fcontId=='187' && this.isMobile" class="info_small print-button">
    </p>
    <p v-else class="text-center print-button">
      <a
        v-on:click="launchPrintGuide()"
        class="btn btn-info btn-lg"
        role="button"
      >
        <LabelFunMessage fcontId="0" msgkey="99" />&nbsp;&raquo;
      </a>
    </p>

    <!-- 印刷方法案内 -->
    <modal
      v-model="isShowModal"
      class="modal fade"
      id="modal1"
      ref="modal"
      size="lg"
      :footer="false"
    >
      <div slot="title">
        <h3 class="modal-title">
          <LabelFunMessage fcontId="0" msgkey="102" />
          </h3>
      </div>

      <div>
        <div>
          <!-- デザインペーパー印刷方法 -->
          <ul v-if="contentTypeId=='designpaper'" class="list-group">
            <PrintMenuCreativePrint v-bind="contentsInfo" />
            <PrintMenuPhotoPlus  v-bind="contentsInfo" />
            <PrintMenuWebApp v-bind="contentsInfo" />
            <PrintMenuLinePrint v-bind="contentsInfo" />
            <PrintMenuPrinter/>
          </ul>

          <!-- デザインペーパープレミアムコレクション印刷方法 -->
          <ul v-if="contentTypeId=='designpaperPremiumCollection'" class="list-group">
            <PrintMenuCreatePlus v-bind="contentsInfo" />
            <PrintMenuWebApp v-if="isNotLocalChina" v-bind="contentsInfo" />
            <PrintMenuLinePrint v-if="isNotLocalChina" v-bind="contentsInfo" />
          </ul>

          <!-- 写真レイアウト印刷方法 -->
          <ul v-if="contentTypeId=='photoLayout'" class="list-group">
            <PrintMenuCreativePrint v-bind="contentsInfo" />
            <PrintMenuPhotoPlus  v-bind="contentsInfo" />
          </ul>

           <!-- フォトブック印刷方法 -->
           <ul v-if="contentTypeId=='photobook'" class="list-group">
            <PrintMenuCreativePrint v-bind="contentsInfo" />
            <PrintMenuPhotoPlus  v-bind="contentsInfo" />
          </ul>

          <!-- フリーレイアウト印刷方法 -->
          <ul v-if="contentTypeId=='freeLayout'" class="list-group">
            <PrintMenuCreativePrint v-bind="contentsInfo" />
            <PrintMenuPhotoPlus  v-bind="contentsInfo" />
          </ul>

          <!-- グリーティングカード印刷方法 -->
          <ul v-if="contentTypeId=='greetingCards'" class="list-group">
            <PrintMenuCreativePrint v-bind="contentsInfo" />
            <PrintMenuPhotoPlus v-bind="contentsInfo" />
          </ul>

          <!-- 年賀状/はがき印刷方法 -->
          <ul v-if="usePostcardApp" class="list-group">
            <PrintMenuColorioNenga v-bind="contentsInfo" />
            <PrintMenuPhotoPlus v-bind="contentsInfo" />
          </ul>

          <!-- アルバム印刷方法 -->
          <ul v-if="contentTypeId=='album'" class="list-group">
            <PrintMenuCreativePrint v-bind="contentsInfo" />
            <PrintMenuPhotoPlus  v-bind="contentsInfo" />
          </ul>

          <!-- CreativePrint起動のみの連携 -->
          <ul v-if="contentTypeId=='creativeTop'" class="list-group">
            <PrintMenuCreativePrint v-bind="contentsInfo" />
          </ul>

        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";
import { mapState, mapGetters } from "vuex";
import { Modal } from "uiv";
import { LAUNCH_TYPE, CONTENTS_INFO, CONTENT_TYPE, PAPER_SIZE, PAPER_TYPE } from "@/common/contentsinfo";
import designpaperList from "../assets/design_papers_and_categories.json";

import PrintMenuWebApp from "./PrintMenuWebApp";
import PrintMenuCreativePrint from "./PrintMenuCreativePrint";
import PrintMenuColorioNenga from "./PrintMenuColorioNenga";
import PrintMenuPhotoPlus from "./PrintMenuPhotoPlus";
import PrintMenuLinePrint from "./PrintMenuLinePrint";
import PrintMenuPrinter from "./PrintMenuPrinter";
import PrintMenuCreatePlus from "./PrintMenuCreatePlus";

export default {
  name: "PrintButton",
  data() {
    return {
      isShowModal: false,
    };
  },
  props: {
    launchType: String,  // select, print
    fcontId: String,
    contentType: String, // designpaper, photoLayout, nenga など
    designId: String, // designPaperの場合：xx-xx ※指定しない場合はundefinedとする

    location_id: {  // 記事の作り方内で使う場合はmethodを入れる。複数ある場合は末尾に追番を入れる。
      type: String,
      default: "upper", 
      required: false
    }
  },
  components: {
    LabelFunMessage,
    Modal,
    PrintMenuWebApp,
    PrintMenuCreativePrint,
    PrintMenuColorioNenga,
    PrintMenuPhotoPlus,
    PrintMenuLinePrint,
    PrintMenuPrinter,
    PrintMenuCreatePlus
  },
  computed: {
    ...mapState(["os","lg2"]),
    ...mapGetters(["isWwTemplate", "isJpTemplate"]),
    isPc: function () {
      return this.os == "ws" || this.os == "mi";
    },
    isMobile: function () {
      return this.os == "ios" || this.os == "ard";
    },
    isSupport: function () {
      switch (this.contentTypeId) {
        case CONTENT_TYPE.designpaper:
        case CONTENT_TYPE.photoLayout:
        case CONTENT_TYPE.freeLayout:
        case CONTENT_TYPE.album:
        case CONTENT_TYPE.greetingCards:
        case CONTENT_TYPE.designpaperPremiumCollection:
        case CONTENT_TYPE.createplusContents:
          return true;
        case CONTENT_TYPE.nenga:
        case CONTENT_TYPE.postcard:
        case CONTENT_TYPE.mochu:
        case CONTENT_TYPE.photobook:
          return this.isJpTemplate
        case CONTENT_TYPE.creativeTop:
          return this.isMobile;
        default:
          return false;
      }
    },
    // コンテンツ関連
    contentsInfo: function () {
      return {
        launchType: this.launchType,
        contentType: this.contentTypeId,
        categoryId: this.categoryId,
        designId: this.designId,
        mediaSizeId: this.mediaSizeId,
        mediaTypeId: this.mediaTypeId,
        fcontId: this.fcontId,
        createplusCategoryId: this.createplusCategoryId,
        createplusSubCategoryId: this.createplusSubCategoryId,
        location_id: this.location_id
      }
    },
    contentTypeId: function () {
      switch(this.launchType) {
        case LAUNCH_TYPE.select:
          return CONTENTS_INFO[this.fcontId].content_type
        case LAUNCH_TYPE.print: 
          return this.contentType
        default:
          return ""
      }
    },
    categoryId: function () {
      switch(this.launchType) {
        case LAUNCH_TYPE.select:
          return CONTENTS_INFO[this.fcontId].category_id
        case LAUNCH_TYPE.print: {
          const item = designpaperList.designPapers.find( function (item) {
              return item.id == this.designId;
            }.bind(this)
          );
          return item.categoryId;
        }
        default:
          return ""
      }
    },
    mediaSizeId: function () {
      if(this.fcontId != undefined) {
        if (CONTENTS_INFO[this.fcontId].media_size != undefined) {
          return CONTENTS_INFO[this.fcontId].media_size
        }
        return PAPER_SIZE.A4
      }else {
        return PAPER_SIZE.A4
      }
    },
    mediaTypeId: function () {
      if(this.fcontId != undefined) {
        if (CONTENTS_INFO[this.fcontId].media_type != undefined) {
          return CONTENTS_INFO[this.fcontId].media_type
        }
        return PAPER_TYPE.plain
      }else {
        return PAPER_TYPE.plain
      }
    },
    usePostcardApp: function () {
      return (this.contentTypeId == CONTENT_TYPE.nenga) || (this.contentTypeId == CONTENT_TYPE.postcard) || (this.contentTypeId == CONTENT_TYPE.mochu)
    },
    isNotLocalChina: function () {
      return window.location.host != "support.epson.com.cn"
    },
    createplusCategoryId: function () {
      if(this.fcontId != undefined) {
        return CONTENTS_INFO[this.fcontId].createplus_category_id
      }
      return undefined
    },
    createplusSubCategoryId: function () {
      if(this.fcontId != undefined) {
        return CONTENTS_INFO[this.fcontId].createplus_subcategory_id
      }
      return undefined
    },
  },
  beforeDestroy: function () {
    // モーダルを開いた状態でデザインペーパーサンプルページから記事ページに戻るとスクロールが効かなくなる不具合対応
    if (document.body.className == "modal-open") {
      document.body.className = ""
    }
  },
  methods: {
    launchPrintGuide: function () {  
      if (this.contentTypeId == CONTENT_TYPE.createplusContents) {
        // モーダルを開かずに、Create＋のテンプレート一覧ページを別タブで開く
        let categoryid = CONTENTS_INFO[this.fcontId].createplus_category_id
        let subcategoryid = CONTENTS_INFO[this.fcontId].createplus_subcategory_id
        this.$gtag.event("go_create", {
          "article_no": this.fcontId,
          "location_id": this.location_id,
          "item_category2": subcategoryid
        })
        let resolvedRoute = this.$router.resolve({ 
          path: "/createplus/" + this.lg2 + "/templates/" + categoryid + "/" + subcategoryid,
          query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
         });
        window.open(resolvedRoute.href, '_blank');        
      } else {
        this.$gtag.event("proceed_print", {
          "print_type": this.launchType,
          "article_no": this.fcontId,
          "design_id": this.designId,
          "location_id": this.location_id
        })
        this.isShowModal = true;
      }
    },
  },
  metaInfo() {
    return {
      link: [
        { rel: 'stylesheet', href: process.env.VUE_APP_ROOT + '/assets/common/css/printbutton_menu.css' }
      ]
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-content {
  background-color: white;
}

.list-group-item {
  font-size: 18px;
}

p.print-button {
  margin-top: 20px;
  margin-bottom: 0px;
}

p.print-button a {
  padding: 10px 5px;
  width: 100%;
  max-width: 720px;
}

.app-menu {
  padding: 15px;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
  .modal-title {
    font-size: 18px;
  }

  .app-menu {
    padding: 10px;
  }
}
</style>